<template>
    <div class="public_container">
        <Head></Head>
        <div class="mobile_container">
            <div class="no_company_container">
                <ul>
                    <li>
                        <div class="left">
                            <div class="title">
                                <img src="https://download.hecoos.com/enlightv/2024-42/78467bccfa7a96dd19e105d952e94416.png" alt="">
                                <span>如何加入公司</span>
                            </div>
                            <p>可联系公司人事邀请您加入</p>
                            <a href="javascript:;" @click="handleClickJoinCompany">加入<van-icon name="arrow" /></a>
                        </div>
                        <div class="right">
                            <img src="https://download.hecoos.com/enlightv/2024-42/31d55073086cd050cbd0992a1e8fb873.png" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="left">
                            <div class="title">
                                <img src="https://download.hecoos.com/enlightv/2024-42/4764a5ff9ca0540afae5c8c40c32c164.png" alt="">
                                <span>创建新公司</span>
                            </div>
                            <p>您可以点击此处创建新公司</p>
                            <a href="javascript:;" @click="handleClickRegisteringCompany">创建<van-icon name="arrow" /></a>
                        </div>
                        <div class="right">
                            <img src="https://download.hecoos.com/enlightv/2024-42/f4f58720a58e854b5c2c768aa3adac73.png" alt="">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <van-popup v-model="joinCompanyPopupShow"  closeable round :style="{ width: '90%' }" >
            <div class="join_company_popup">
                <div class="title">如何加入公司</div>
                <p>
                    您还未使用{{userInfo.phone}}加入任何公司 <br>
                    请联系您公司管理员在<span>人员组织</span>中通过 <br>
                    【邀请加入】或【新增员工】的方式加入公司
                </p>
            </div>
        </van-popup>
    </div>
</template>
<script>
import Head from '@/components/mComponents/Head.vue'
import {mapState} from "vuex";
export default {
    name: 'mobileNoCompany',
    data () {
        return {
            joinCompanyPopupShow:false
        }
    },
    computed: {
        ...mapState(['userInfo']),
    },
    mounted () {

    },
    methods: {
        // 加入公司
        handleClickJoinCompany(){
            this.joinCompanyPopupShow = true
        },
        // 创建公司
        handleClickRegisteringCompany(){
            this.$router.push({
                name: 'mobileRegisteringCompany'
            })
        },
    },
    components: {
        Head,
    }
}
</script>

<style lang="scss" scoped>

</style>
